import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { Logout } from './modules/login/logout';
import ClaimDeclareStepsEngine from './modules/step-engine/ui/container/claim-declare-steps-engine';
import PrivateRoute from './shared/auth/private-route';
import { WrongRoute } from './shared/auth/wrong-route';
import './style.scss';
import PublicRoute from './shared/auth/public-route';
import NotFound from './not-found';

const Routes = () => (
	<Switch>
		<PublicRoute path="/" exact component={ClaimDeclareStepsEngine} />
		<PrivateRoute path="/claim-declare/:subscriptionNumber?" component={ClaimDeclareStepsEngine} />
		<Redirect from="/login-error/:subscriptionNumber" to="/claim-declare/:subscriptionNumber" />
		<Route path="/logout" component={Logout} />
		<Route path="*" component={NotFound} />
	</Switch>
);
export default Routes;